/**
 * @generated SignedSource<<0409a1c73e011986dc7816530999c71b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AuthenticateTransactionMutation$variables = {
  token: string;
};
export type AuthenticateTransactionMutation$data = {
  readonly unified: {
    readonly linking: {
      readonly authenticateLinkingWithLoggedInAccount: {
        readonly account1?: {
          readonly aaid: string | null;
          readonly emailId: string | null;
        } | null;
        readonly account2?: {
          readonly aaid: string | null;
          readonly emailId: string | null;
        } | null;
        readonly errors?: ReadonlyArray<{
          readonly code: string | null;
          readonly extensions: {
            readonly errorType: string | null;
            readonly statusCode: number | null;
          } | null;
          readonly message: string | null;
        }> | null;
        readonly id?: string;
        readonly message?: string | null;
        readonly primaryAccountIndex?: number | null;
        readonly success?: boolean;
        readonly token?: string;
      } | null;
    } | null;
  } | null;
};
export type AuthenticateTransactionMutation = {
  response: AuthenticateTransactionMutation$data;
  variables: AuthenticateTransactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aaid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailId",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryAccountIndex",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedMutationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UnifiedMutationErrorExtension",
          "kind": "LinkedField",
          "name": "extensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "errorType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "statusCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedLinkingStatusPayload",
  "abstractKey": null
},
v10 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthenticateTransactionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedMutation",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedLinkingMutation",
            "kind": "LinkedField",
            "name": "linking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "authenticateLinkingWithLoggedInAccount",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAccountDetails",
                        "kind": "LinkedField",
                        "name": "account2",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAccountDetails",
                        "kind": "LinkedField",
                        "name": "account1",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "type": "UnifiedLinkAuthenticationPayload",
                    "abstractKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthenticateTransactionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedMutation",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedLinkingMutation",
            "kind": "LinkedField",
            "name": "linking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "authenticateLinkingWithLoggedInAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAccountDetails",
                        "kind": "LinkedField",
                        "name": "account2",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAccountDetails",
                        "kind": "LinkedField",
                        "name": "account1",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "type": "UnifiedLinkAuthenticationPayload",
                    "abstractKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a987e7f926cda4a45909fe2893424044",
    "id": null,
    "metadata": {},
    "name": "AuthenticateTransactionMutation",
    "operationKind": "mutation",
    "text": "mutation AuthenticateTransactionMutation(\n  $token: String!\n) {\n  unified {\n    linking {\n      authenticateLinkingWithLoggedInAccount(token: $token) {\n        __typename\n        ... on UnifiedLinkAuthenticationPayload {\n          id\n          account2 {\n            aaid\n            emailId\n            id\n          }\n          account1 {\n            aaid\n            emailId\n            id\n          }\n          token\n          primaryAccountIndex\n        }\n        ... on UnifiedLinkingStatusPayload {\n          message\n          success\n          errors {\n            extensions {\n              errorType\n              statusCode\n            }\n            code\n            message\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2cdb850a38b204dfdb2d1aa5232d9108";

export default node;
